export const nodeType = {
  filterOperator: "filter",
  orOperator: "or",
  notOperator: "not",
  andOperator: "and",
  plainText: "plainText",
}
